module.exports = __webpack_public_path__ + "images/liinilaevad/apple-icon-152x152.png";